/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Features_Client_Next_WhenInputs */

const en_features_client_next_when = /** @type {(inputs: Features_Client_Next_WhenInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Thursday, 18:30 · 1:1 session`)
};

const pl_features_client_next_when = /** @type {(inputs: Features_Client_Next_WhenInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Czwartek, 18:30 · Trening 1:1`)
};

/**
* | output |
* | --- |
* | "Thursday, 18:30 · 1:1 session" |
*
* @param {Features_Client_Next_WhenInputs} inputs
* @param {{ locale?: "en" | "pl" }} options
* @returns {LocalizedString}
*/
export const features_client_next_when = /** @type {((inputs?: Features_Client_Next_WhenInputs, options?: { locale?: "en" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Features_Client_Next_WhenInputs, { locale?: "en" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pl") return pl_features_client_next_when(inputs)
	return en_features_client_next_when(inputs)
});